<template>
    <div class="page white_bg" style="padding-bottom: 91px">

        <!-- VIP免费尊享课程 -->
        <header class="pageHeader relative">
            <div style="width:100%;height:100%;" class="listBg cover"></div>
            <div class="titleArea f24 fWeight600 white">
                <div class="paddingH16">{{title}}</div>
            </div>
            <div class="descArea f12 fWeight400 white showEllipsisIfOverflow hiddenOverflow"
                 style="height: 3em; line-height: 1.5em;">
                <div class="paddingH16">{{desc}}</div>
            </div>
            <div class="open_vip_button_absolute_right">
                <router-link to="/vip">
                    <img class="image" src="vip/open_vip_button_absolute_right.png" alt="开通VIP享特惠"/>
                </router-link>
            </div>
        </header>

        <div class="body white_bg" style="position: relative; top: -40px;">
            <div class="inner" style="padding: 32px 16px 0;">

                <div class="list clearfix" :class="layout">
                    <div style="margin-bottom:24px;" class="item" v-for="(dataItem, index) in dataList"
                         :key="dataItem.id" @click="viewItem(dataItem)">

                        <!-- 水平3卡片布局 -->
                        <div class="inner" v-if="layout === 'horizontal3CardLayout'">
                            <div class="imageArea marginB8">
                                <img class="cover fullSpace" :src="dataItem.coverImg"/>
                                <div class="descArea f12 white">
                                    共{{dataItem.applyCount}}人学
                                </div>
                            </div>
                            <div class="titleArea f16 fWeight600 color333">{{dataItem.title}}</div>
                        </div>

                        <!-- 纵向图文布局 -->
                        <div class="inner flexLayout" v-if="layout === 'verticalImageTextLayout'">
                            <div class="imageArea" style="width: 120px;">
                                <img class="cover fullSpace" :src="dataItem.coverImg"/>
                            </div>
                            <div style="overflow:hidden;" class="flexItem paddingL8">
                                <div class="titleArea f14 grey20 fWeight500"
                                     style="margin-bottom: 2px; line-height: 1.375em; height: 1.375em;white-space: nowrap;">
                                     <i style="vertical-align: middle;margin-right: 2px;" class="vip_title_icon"></i>{{dataItem.title}}
                                </div>
                                <div style="margin-top:4px;" class="descArea f12 fWeight400 grey60">
<!--                                    共{{dataItem.courseCount}}节课-->
                                </div>
                                <div class="clearfix">
                                    <div class="priceArea floatL">
                                        <span class="descArea f12 fWeight400 grey60">    共{{dataItem.courseCount}}节课</span>
                                        <!-- <span style="color:#333;" class="fWeight400 f10">组合价:</span> -->
<!--                                        <strong class="red font12r fWeight600">￥</strong>-->
<!--                                        <strong class="red f14 fWeight400">{{dataItem.price}}</strong>-->
                                        <span class="textDelete grey70 font10r fWeight400" style="margin-left: 4px;">
<!--                                            ￥{{dataItem.marketPrice || 0}}-->


                                        </span>
                                    </div>
                                    <div class="learningArea fr f12 grey20 fWeight400" style="padding-top: 4px;">
                                        {{dataItem.applyCount}}人在学
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 表格两栏卡片布局 -->
                        <div class="inner" v-if="layout === 'table2ColumnCardLayout'">
                            <div class="imageArea marginB8 roundBorder8">
                                <img class="cover fullSpace" :src="dataItem.coverImg"/>
                            </div>
                            <div class="titleArea f16 color333 fWeight600 marginB8 textOverflowShowEllipsis">
                                {{dataItem.title}}
                            </div>
                            <div class="descArea f12 grey20 fWeight400">
                                共{{dataItem.applyCount}}人学
                            </div>
                        </div>

                    </div>
                </div>

            </div><!-- end .inner -->
        </div><!-- end .body -->

<!--        <div class="font12r grey60 alignCenter" style="padding: 26px 0 9px;"-->
<!--             v-show="status=='ready' && pagination.current == pagination.totalPage"-->
<!--             :data-current="pagination.current" :data-total="pagination.totalPage || 0">-->
<!--            -没有更多啦- -->
<!--        </div>-->

            <!-- disable in 2021-03-15-->
<!--        <div class="font12r grey60 alignCenter">-->
<!--            <router-link to="/learn" style="color: #8994A9;">更多VIP免费在“马上学”</router-link>-->
<!--        </div>-->

        <div class="generalPagePaddingH">
            <adModule :type="adTypeEnum.VIP_EXALTED_PAGE.code" version="4"/>
        </div>

        <a class="fixedBackIcon" href="javascript:;" @click="back()">
            <i class="backIcon"></i>
        </a>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// data
import externalApp from '@data/externalApp';
import adTypeEnum from '@/components/ad/adTypeEnum';

// config
import appConfig from '../../appConfig';

// modules
import adModule from '@comp/ad/oneImageAdModule'

// util
import consoleHelper from '@util/consoleHelper';
import stringHelper from '@util/stringHelper';
import wechatHelper from '@util/wechatHelper';
import appHelper from '@util/appHelper';
import htmlHelper from "@util/htmlHelper";

const config = {
    apiConfig : {
        list : {
            url : 'portal/v4/index/getVipVodList',
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages',
        }
    }
};

export default {
    name: "vipCourseIndex",
    extends : shixunPagePart,
    components : { adModule },
    data () {
        return {
            adTypeEnum : adTypeEnum,
            title : 'VIP免费尊享',
            desc : '开通VIP  尊享1000+门特权好课',
            apiConfig : config.apiConfig,
            layout : 'verticalImageTextLayout',
            enableDataList :true,
            autoLoadDataList : appConfig.mode != 'demo',
            scrollToLoadNextPage : true
        }
    },
    methods : {
        viewItem(dataItem) {
            appHelper.redirect('/learn/course/' + dataItem.id);
        },
        setWechatShare() {

            let wechatShareOptions = {
                title: appHelper.getTitle(), // 分享标题
                desc: this.desc || appConfig.wechat.defaultDescription, // 分享描述
                link: appHelper.generateShareUrl('/vipCourse'),
                imgUrl: appHelper.getAppIcon(), // 分享图标
                type: '', // 分享类型,music、video或link，不填默认为link
            };

            wechatHelper.setShare(wechatShareOptions);
        }
    },
    mounted() {


        this.setWechatShare();
    }
}
</script>

<style lang="scss" scoped>
.pageHeader {

    position: relative;
    height: 215px;
    .bg, .titleArea, .descArea {
        position: absolute;
        height: 100%;
        width: 100%;
        left: 0;
        background-size: 100% 100%;
        background-size: cover;
    }
    .bg {
        z-index: 1;
        background: #D6D6D6;
        filter: blur(10px);
        top: 0;
    }
    .titleArea, .descArea {
        z-index: 2;
        height: 100%;

    }
    .titleArea {
        top: 74px;
    }
    .descArea {
        top: 113px;
    }

}

.vip_title_icon{
    display: inline-block;
    width: 45px;
    height: 13px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url(data:image/png;base64,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);
}




.imageArea {
    position: relative;
    // &:before {
    //     content : '';
    //     display: block;
    //     width: 45px;
    //     height: 14px;
    //     background-image: url('data:image/svg+xml;base64,PHN2ZyBpZD0i57uEXzg1MyIgZGF0YS1uYW1lPSLnu4QgODUzIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NSIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDQ1IDE0Ij4NCiAgPGRlZnM+DQogICAgPHN0eWxlPg0KICAgICAgLmNscy0xIHsNCiAgICAgICAgZmlsbDogIzJjMmMyYzsNCiAgICAgICAgb3BhY2l0eTogMC45NDsNCiAgICAgIH0NCg0KICAgICAgLmNscy0yIHsNCiAgICAgICAgZmlsbDogI2ZmZWVkZjsNCiAgICAgICAgZm9udC1zaXplOiA5cHg7DQogICAgICAgIGZvbnQtZmFtaWx5OiAuUGluZ0ZhbmctU0MtTWVkaXVtLCAnLlBpbmdGYW5nIFNDJzsNCiAgICAgICAgbGV0dGVyLXNwYWNpbmc6IDAuMDJlbTsNCiAgICAgICAgZm9udC13ZWlnaHQ6IDUwMDsNCiAgICAgIH0NCiAgICA8L3N0eWxlPg0KICA8L2RlZnM+DQogIDxnIGlkPSLnu4RfODU0IiBkYXRhLW5hbWU9Iue7hCA4NTQiPg0KICAgIDxwYXRoIGlkPSLot6/lvoRfMTk1IiBkYXRhLW5hbWU9Iui3r+W+hCAxOTUiIGNsYXNzPSJjbHMtMSIgZD0iTTYsMEg0NVY4YTYsNiwwLDAsMS02LDZIMFY2QTYsNiwwLDAsMSw2LDBaIi8+DQogICAgPHRleHQgaWQ9IlZJUOWFjei0uSIgY2xhc3M9ImNscy0yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2IDEwKSI+PHRzcGFuIHg9IjAiIHk9IjAiPlZJUOWFjei0uTwvdHNwYW4+PC90ZXh0Pg0KICA8L2c+DQo8L3N2Zz4NCg==');
    //     background-repeat: no-repeat;
    //     position: absolute;
    //     z-index: 1;
    //     left: 0;
    //     top: 0;
    // }
}


.body {
    position: relative;
    z-index: 2;
    /* alter at 2020-12-10
     */
    /*border-radius: 30px 30px 0px 0px;*/
    border-radius: 16px 16px 0px 0px;
}

.horizontal3CardLayout {
    display: flex;
    .item {
        margin-right: 10px;
        flex: 1;
        &:last-child {
            margin-right: 0;
        }
    }

    .imageArea {
        height: 120px;
        border-radius: 8px;
        position: relative;
        overflow: hidden;
    }

    .descArea {
        position: absolute;
        z-index: 1;
        bottom: 0;
        left: 0;
        width: 100%;
        /*height: 20px;*/
        box-sizing: border-box;
        padding: 2px 10px;
        line-height: 20px;
        background-color: rgba(0,0,0,.5);
    }

    .titleArea {
        line-height: 1.25em;
        height: 2.5em;
        overflow: hidden;
    }
}/* end .horizontal3CardLayout */

.verticalImageTextLayout {
    .item {
        margin-bottom: 14px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .numberArea {
        .flag_1 {
            width: 16px;
            height: 22px;
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAsCAYAAAAEuLqPAAABbUlEQVRYhe3TL0gDYRjH8dMJImgQzGI0mC2WGVem5RXu3t97G6YLlgVhccUwNFtNWgRZWbM5hDWLZagYBMdQcU5BdONnEM47dTrn/WHwPvCEJ30/4X0NKlWOcXcNKvUQ455pgAYMIMBxWqxWX+mdYvEpGkAu1+L5eZufJxJAPv/IRqPzJR4ZoFR6doP1eic+QK3WpuO04gFUKi/uHcsb8N6x/AIN0AAN0AANCH41QAMGH1AicBQXYItCJCjEGIG9KAF3lHLV8AwNY4hAgUAzbMAVbXvR6DIEVqjUTTgA4ISmOdst7iIsa55KXQQLAMq0rMnf4i5CiGkqdRwMANhmMjnSa9yDGCew3z8AuCew9tewD1EoDBPY6AdwTSlT/4n7IFKCSt32BgBOqdRcUHEXkcksELj8GQAc0jSngo67iGx2hkpVvwdIucNUajSsuItIpycIHHwAgCaB9bDDPoQQCdr25jvAtpeijPsgwPIbwM3Y+AjpRPAAAAAASUVORK5CYII=');
            background-repeat: no-repeat;
        }
        .flag_2 {
            width: 16px;
            height: 22px;
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAsCAYAAAAEuLqPAAACVElEQVRYhe3UPWgTYRzH8WgFEXQQnMXRwdnFRccu6hKhzXNVnDq4FBEyZnHwDUGom6TPxZYaiRqwOqTSoUVRQQq2Wm0bHJSYvkja3DUvl7uv0yXXkmjumkso5Af/KXC/T563gKIy0cEZDSiSzQ7OUhfQBewtwK0U+lwGQy9hARQMrPQaleFptnwHJGYpVkzqxrIg9ZWyb4BwEs1wlBsmrOuY5cp2xP0p1yvRHCD+iaJdpJewwkk0RbI5lCC/plGlzSy7XoXmAJ8zGFtlrK0yVmqBkvO3Jw5cNo/p6yGsN6/mKdmAX7k2A64/R7NvBMDO1fEVMDhOPrNR23+9hDWUIN82wPcVqnfAMOHeG3QP3/EGmFmm7Lx+jz9S8PhH3ANeztUOHcDrL6733TtA/UDBsmrl79KeXj9vgNuT6M7XcHGVyi7LmweEk2hFo3bdfm9iDo67PvHeAQtZKs59zxWwVjXMnfMt63pVmgMsrmwHNMqq5tNL2HGAj9MFdAF7H/BCSKY7A1C5G4zTE4xzSMQYax9A5U9IcjXgDOwTUSJCsuE34OeA5FygQUSMS4pkzReAkMz2RTnZqNxO/yinFUm6pQChMtE/ytH/ldsJqhxXJG9bAhAqD89OcaDZ8ipimMNC8tQzQKjkRIxrboudiUTYLyQ3vQAyIUnvbsqdCUmEMsJ6UwChMq+onGpVuZ3LI5wRKj/+CRCSyb4xjrW63M6VKCcUlfd1AaERor0POOhXuZ3zjzgiJM+qACHZEJIbfhc7E4zTMyC5o0iWAgOSC+0sd0bEuPgX1OUukZIspmEAAAAASUVORK5CYII=');
            background-repeat: no-repeat;
        }
        .flag_3 {
            width: 16px;
            height: 22px;
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAsCAYAAAAEuLqPAAACaElEQVRYhe3UPYgTQRQH8OgJImghWIulhbWNjZbXqE2Eu8xEsbKwOUQQsQiIiF+FgiIIBgsFcyCKXmaikRAiweP8DhFjDk/lNGAu39nd3O7O/i0Cu7fEeEkuk3CQB6/ZLf4/3sw8DxidGVpzet8DRqtD7PkRYARYZ4D3N1SUsyZMzQIA6DULhZSBuYuKfMCPFzqsZm5LCQPIPGzIA7y7rroDdaBRELBM97fEmbocQCnjJGlLAvGpGhit4tXZun0cAPA11O0UOgQUMya0vICWF0jf1Vz/FhO6DSh+MeVewn917rUD+J3UBwtI3dEgnPyW6UgDzF1SWl5CKdvt+PsIEDrw5nIvu6BHwOx5BVpeuMYvdCB5TtIzbNfxqRqUnLARhZQxWACjVXwOajZguWrJARiKBUNt9ttrqhtwzwHoNUmARtHZduV5E9ETzU0YP1WH+sc5gsqCpEW0EF5uufVaXkAY7qf46bbEPVDKmvhf/XzZ7Rbs4RKmgxrqvwQMtXkkhmKhnDXx8abaQ3gPgP73CDACrHdAhD4GI4nhADi9ipB3DEnvFnDyYJCAIsK+454VBXg2gJEAOKnIBiwi6j/gaVPg5AgYXZID4OQDIhO724U7iMm94PRbnwFkBs8mt68WbiOeeneC0WR/AJzcQmz/pk7DbUTIuxWMTK8BQMrg5GS3wS5EILARnFzoHsBpDhHf+FrCXRDmI2C00CGApBGhe/oVbiOeH90HRr6vAiBRxCZ29DvcRsSO7QKns20AviDC45tlhduIJwe3gZFHKwCkAkZOyw52IULeMTD/lSaA+w8NMtwFiZDDfwE9GI1HJIyOhAAAAABJRU5ErkJggg==');
            background-repeat: no-repeat;
        }

    }
    .imageArea {
        height: 80px;
        border-radius: 8px;
        overflow: hidden;
    }
    .titleArea {
        line-height: 1.33em;
        height: 1.33em;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .descArea {
        line-height: 1.33em;
        height: 1.33em;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 16px;
    }
}/* end .verticalImageTextLayout */

.table2ColumnCardLayout {
    /*padding-left: 10px;*/
    .item {
        float:left;
        width: 50%;
        height: 140px;
        box-sizing: border-box;
        padding-right: 10px;
        margin-bottom: 16px;
    }
    .imageArea {
        height: 80px;
        overflow: hidden;
    }
    .titleArea {
        line-height: 1.33em;
        height: 1.33em;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
    }
    .descArea {
        line-height: 1.33em;
        height: 1.33em;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

</style>
